<template>
  <svg fill="none" height="17" viewBox="0 0 16 17" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 4C10.1233 4 11.8908 5.50262 12.2875 7.50418C13.8042 7.60861 15 8.85016 15 10.3818C15 11.983 13.6933 13.2826 12.0833 13.2826H4.5C2.56917 13.2826 1 11.722 1 9.80163C1 8.00893 2.365 6.52951 4.12083 6.34386C4.85 4.95147 6.31417 4 8 4Z"
      fill="#F9F9F9"
    />
  </svg>
</template>
